var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconObjectType(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.573 10.313v6.75M12.825 15.938a2.25 2.25 0 00-2.25-2.25H7.763a2.25 2.25 0 00-2.25-2.25H1.575v4.5h11.25zM5.51 13.688h2.25M12.635 5.813a2.438 2.438 0 100-4.876 2.438 2.438 0 000 4.875zM16.425 9.563a3.991 3.991 0 00-7.5 0",
    stroke: "#6A737D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgIconObjectType;